import { env } from "../../env/env";

export async function fetchMessages(): Promise<Array<string>> {
	const mucResponse = await fetch(`${env.apiUrl}/clonemuc`);

	if (!mucResponse.ok) throw Error("Error on clone MUC");

	const response = await fetch(`${env.apiUrl}/readlanguages`);

	const languages = await response.json();

	return languages;
}
